module.exports = "#heatmap-legend {\n  position: absolute;\n  z-index: 5;\n  top: 10px;\n  left: 20px;\n  width: 150px;\n  pointer-events: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/maps/heatmaps_discards/_heatmap_discards.component.scss
// module id = ./src/app/maps/heatmaps_discards/_heatmap_discards.component.scss
// module chunks = main